var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57001 17.576C9.0474 17.576 10.4643 16.9891 11.509 15.9444C12.5536 14.8998 13.1405 13.4829 13.1405 12.0055C13.1405 10.5281 12.5536 9.11123 11.509 8.06656C10.4643 7.02189 9.0474 6.435 7.57001 6.435C6.09262 6.435 4.67574 7.02189 3.63107 8.06656C2.5864 9.11123 1.99951 10.5281 1.99951 12.0055C1.99951 13.4829 2.5864 14.8998 3.63107 15.9444C4.67574 16.9891 6.09262 17.576 7.57001 17.576ZM16.514 17.143C18.026 17.143 19.252 14.843 19.252 12.005C19.252 9.167 18.026 6.868 16.514 6.868C15.002 6.868 13.776 9.168 13.776 12.005C13.776 14.843 15.002 17.143 16.514 17.143ZM20.922 16.604C21.512 16.604 21.989 14.544 21.989 12.005C21.989 9.466 21.511 7.407 20.922 7.407C20.332 7.407 19.854 9.466 19.854 12.005C19.854 14.545 20.332 16.604 20.922 16.604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumLogo);
export default __webpack_public_path__ + "static/media/mediumLogo.d312f33c438ed1000b835be7b41242df.svg";
export { ForwardRef as ReactComponent };